module.exports = __webpack_public_path__ + "img/c129a08.png";